export default __webpack_public_path__ + "static/media/linqreveal.da79b451.pdf";